// extracted by mini-css-extract-plugin
module.exports = {"select":"SelectComponent_select__1Ca43"};